export default __webpack_public_path__ + "static/media/rival-shield-red.71033de7.svg";